<template>
    <div 
        id="quartier"
        v-bind:okanMain="okanMain"        
    >    

        <div id="image" :style="{ 'backgroundImage': 'url(\'' + image + '\')' }">
            
        </div>
        <canvas id="overlay"></canvas>
        <canvas id="overlayForHover"></canvas>

        <div class="help" @click="showHelp = !showHelp"></div>
        <div class="helpDiv" v-show="showHelp">
             <span class="rightSpan1">Clic gauche sur le bâtiment à visiter </span>
              <span class="rightSpan2">( coloré au survol )</span>
        </div>

        <div id="vignetteDiv"></div>

        <div id="batNameOverlay"
          v-if="okanMain.hoveredBatiment!= null && !okanMain.showAppartDetails"
        >
          <div class="text">Bâtiment {{getbatName()}}</div>
        </div>         

    </div>

</template>

<script>



export default {
  name: 'Quartier',
  components: {

  },
  props: {
      okanMain : Object,
  },
  data() {
    return {
        showHelp : false,
        image:'./img/quartier/img.jpg'
    }
  },
  methods: {
    getbatName(){
      var _array = this.okanMain.jsonData.AppartsCoords[this.okanMain.hoveredBatiment].appartsAtFrame;
      var found = false;
      var i = 0;
      while (!found && i < _array.length){
        if(_array[i]!=null && _array[i]!=undefined){
          if(_array[i].apparts.length > 0 && _array[i].apparts[0].batName != undefined){
            found = true;
            return  _array[i].apparts[0].batName;
          }
        }
        i++;
      }
      return "";
    },
        
  },
  mounted() {
      
  }
}
</script>

<style src="../assets/css/quartier.css"></style>